import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';

import { PullRequestState } from 'src/components/types/src/pull-request';
import { useIntl } from 'src/hooks/intl';

import { messages } from './pull-request-activity-events.i18n';
import * as styles from './pull-request-event.styled';

const statusAppearance: {
  [k: string]: React.ComponentProps<typeof Lozenge>['appearance'];
} = {
  OPEN: 'inprogress',
  MERGED: 'success',
  DECLINED: 'removed',
  SUPERSEDED: 'moved',
  DRAFT: 'default',
};

const statusMessage = {
  OPEN: messages.openedEventLozenge,
  MERGED: messages.mergedEventLozenge,
  DECLINED: messages.declinedEventLozenge,
  SUPERSEDED: messages.supersededEventLozenge,
  /* COREX-9393: Allow this to be translated once we start to roll out bbc_draft_prs */
  DRAFT: {
    id: 'frontbucket.repository.pullRequest.pullRequestActivityEvents.draftEventLozenge',
    description:
      'lozenge label in activity feed component when a user creates a draft pull request',
    defaultMessage: 'DRAFTED',
  },
};

type Props = {
  status: PullRequestState;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const PullRequestStatusEntry: React.FC<Props> = ({ status }: Props) => {
  const intl = useIntl();
  const lozengeText = intl.formatMessage(statusMessage[status]);

  return (
    <Fragment>
      <Lozenge isBold appearance={statusAppearance[status]}>
        {lozengeText}
      </Lozenge>
      <styles.MessageText>
        <FormattedMessage {...messages.pullRequestContextMessage} />
      </styles.MessageText>
    </Fragment>
  );
};
